(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pdp-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const galleryMain = document.querySelector('.gallerySwiperMain');
    const galleryThumbs = document.querySelector('.gallerySwiperThumbs');
    
    if (galleryMain && !galleryMain.swiper && typeof Swiper !== 'undefined') {
      const thumbsSwiper = galleryThumbs ? new Swiper('.gallerySwiperThumbs', {
        spaceBetween: 8,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          640: {
            slidesPerView: 4,
          }
        }
      }) : null;

      new Swiper('.gallerySwiperMain', {
        spaceBetween: 10,
        thumbs: thumbsSwiper ? {
          swiper: thumbsSwiper
        } : null,
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_pdp-quantity"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const quantityWrappers = document.querySelectorAll('.pdp .pdp__quantity');
    
    quantityWrappers.forEach(quantityWrapper => {
      if (quantityWrapper.dataset.initialized) return;
      
      const quantityInput = quantityWrapper.querySelector('input[name="quantity"]');
      const buttons = quantityWrapper.querySelectorAll('.pdp__qty-btn');

      if (!quantityInput || buttons.length === 0) return;

      quantityWrapper.dataset.initialized = 'true';
      
      buttons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const action = this.dataset.action;
          let currentValue = parseInt(quantityInput.value, 10) || 1;
          const maxAttr = parseInt(quantityInput.getAttribute('max'), 10);
          const maxValue = Number.isNaN(maxAttr) ? null : maxAttr;
          
          if (action === 'increase') {
            if (maxValue === null || currentValue < maxValue) {
              currentValue += 1;
            }
          } else if (action === 'decrease' && currentValue > 1) {
            currentValue -= 1;
          }
          
          quantityInput.value = currentValue;
        });
      });

      quantityInput.addEventListener('input', () => {
        if (quantityInput.value === '') return;

        let currentValue = parseInt(quantityInput.value, 10);
        const maxAttr = parseInt(quantityInput.getAttribute('max'), 10);
        const maxValue = Number.isNaN(maxAttr) ? null : maxAttr;
        if (Number.isNaN(currentValue) || currentValue < 1) {
          currentValue = 1;
        }
        if (maxValue !== null && currentValue > maxValue) {
          currentValue = maxValue;
        }

        quantityInput.value = currentValue;
      });

      quantityInput.addEventListener('change', () => {
        if (quantityInput.value === '') {
          quantityInput.value = '1';
          return;
        }

        let currentValue = parseInt(quantityInput.value, 10);
        const maxAttr = parseInt(quantityInput.getAttribute('max'), 10);
        const maxValue = Number.isNaN(maxAttr) ? null : maxAttr;
        if (Number.isNaN(currentValue) || currentValue < 1) {
          currentValue = 1;
        }
        if (maxValue !== null && currentValue > maxValue) {
          currentValue = maxValue;
        }

        quantityInput.value = currentValue;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const formSuccessState = document.querySelector('.form-success-state__wrapper');
    const contactDetails = document.querySelector('.contact-details');
    const contactForm = document.querySelector('.contact-form');
    const contactInfo = document.querySelector('.contact-section__info');
    
    let currentUrl = window.location.href;
    console.log("currentUrl: " + currentUrl);
    if (currentUrl.includes('contact_posted=true')) {
      contactForm.classList.add('hidden');
      contactInfo.classList.add('hidden');
      contactDetails.classList.add('hidden');
      formSuccessState.classList.remove('hidden');
    }
    
  });
  } catch(e) { console.error(e); }
})();

})();
